import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LocalstorageService } from './landing/localstorage.service';

@Injectable()
export class AwakeService {
  awake$ = new Subject<boolean>();
  private readonly NUM_MINUTES_WAKEUP = 1;
  private readonly NUM_MINUTES_TO_RELOAD = 10;
  private readonly domain = location.hostname;
  constructor(private readonly localStorageService: LocalstorageService) {}
  /**
   * Initializes the awake service by adding an event listener for visibility change.
   * If the document becomes hidden, it records the hidden time.
   * If the document becomes visible again, it checks the time difference.
   * If the difference is greater than NUM_MINUTES, it reloads the page.
   * Otherwise, it emits a value to awake$.
   */
  init() {
    let hiddenTime: Date = new Date();
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        hiddenTime = new Date();
      } else {
        const now = new Date();
        const diffInMinutes = (now.getTime() - hiddenTime.getTime()) / 1000 / 60;
        if (diffInMinutes > this.NUM_MINUTES_WAKEUP) {
          this.awake$.next(true);
        } else if (diffInMinutes > this.NUM_MINUTES_TO_RELOAD) {
          this.reload();
        }
      }
    });
  }
  /**
   * Reloads the page or redirects to a specific URL based on the current domain.
   * - For localhost, it simply reloads the page.
   * - For office.lotodobicho.com, it redirects to the HTTPS version of the same domain.
   * - For lotodobicho.com, it redirects to a specific app URL based on the user's selected app.
   */
  private reload() {
    if (this.domain === 'localhost') {
      location.reload();
    } else if (this.domain === 'office.lotodobicho.com') {
      window.location.href = `https://${this.domain}`;
    } else {
      window.location.href = `https://${this.domain}/${this.localStorageService.app_selected()}`;
    }
  }
}
